export const WindowTypes = {
    SET_WINDOW_SIZE: 'SET_WINDOW_SIZE',
    FULLSCREEN: 'FULLSCREEN',
    EXIT_FULLSCREEN: 'EXIT_FULLSCREEN',
    SET_WINDOW_SCROLL: 'SET_WINDOW_SCROLL',
    SHOW_MODAL: 'SHOW_MODAL',
    HIDE_MODAL: 'HIDE_MODAL',
    SET_BROWSER: 'SET_BROWSER'
}